import { Dispatch } from "redux";
import api from "../../api/api";
import { setEventData } from "../reducers/getEventOverviewByTeacherReducer";

const getEventOverviewByStudent = (token: any, eventData: any) => async (
    dispatch: Dispatch
) => {





    try {
        // const courseIdsString = selectedcourselist.join(',');
        //console.log("Year and month",year , month);
        const result = await api.get(`/analytics/dashboard/student/get-event-overview/`, {
            params: {
                ...eventData
            },
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setEventData(result?.data || []))


            //dispatch(setloading(false));
            if (result.data?.status === 200) {
                //dispatch(setCourseList(result.data.data));
                //dispatch(setPagination(result.data));
            } else {
                //dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        // dispatch(setloading(false));
        console.error("Error:", error);
    }
}


export { getEventOverviewByStudent };

//event overview action 


